<template>
<div>
    <a-modal :width="newOrganization ? 832 : 416" v-model="organizationModalVisible" :title="newOrganization ? 'Nieuwe Organisatie' : 'Organisatie aanpassen'" :ok-text="newOrganization ? 'Aanmaken' : 'Aanpassen'" cancel-text="Annuleren" @ok="createOrUpdateOrganization">
        <div class="w-100 d-flex">
          <div :class="newOrganization ? 'col-md-6' : 'col-md-12'">
              <h6>Organisatie informatie</h6>
              <div class="col-md-12">
                <p class="input-label">Organisatienaam*</p>
                <a-input class="mb-2" v-model="organizationInformation.name" />
                <a-checkbox class="mb-2" v-model="organizationInformation.departments_enabled">
                  Afdelingen
                </a-checkbox>
                <a-checkbox class="ml-0 mb-2" v-model="organizationInformation.multiuser_enabled">
                  Multi-user organisatie
                </a-checkbox>
                <a-checkbox class="ml-0 mb-2" v-model="organizationInformation.btw_verlegd">
                  BTW Verlegd
                </a-checkbox>
                <a-checkbox class="ml-0 mb-2" v-model="organizationInformation.commission">
                  Commissie
                </a-checkbox>
                <a-checkbox class="ml-0 mb-2" v-model="organizationInformation.include_csv">
                  CSV
                </a-checkbox>
                <br/>
                <a-checkbox class="ml-0 mb-2" v-model="organizationInformation.hide_reservations_to_organization">
                  Verberg reserveringen voor organisatie
                </a-checkbox>
                <p class="input-label" v-show="organizationInformation.commission">Commissie Percentage</p>
                <a-input-number id="inputNumber" v-show="organizationInformation.commission" v-model="organizationInformation.commission_amount" :min="1" :max="100"/>
                <p class="input-label">Straatnaam + Huisnummer*</p>
                <a-input class="mb-2" v-model="organizationInformation.streetname_housenumber" />
                <p class="input-label">Postcode*</p>
                <a-input class="mb-2" v-model="organizationInformation.zipcode" />
                <p class="input-label">Stad*</p>
                <a-input class="mb-2" v-model="organizationInformation.city" />
                <p class="input-label">Land*</p>
                <a-input class="mb-2" v-model="organizationInformation.country" />
                <p class="input-label">Telefoonnummer*</p>
                <a-input class="mb-2" v-model="organizationInformation.phone_number" />
                <p class="input-label">KVK nummer*</p>
                <a-input class="mb-2" v-model="organizationInformation.coc_number" />
                <p class="input-label">Factuur e-mailadres*</p>
                <a-input class="mb-2" v-model="organizationInformation.invoice_email" />
              </div>
          </div>
          <div v-if="newOrganization" class="col-md-6">
            <h6>Hoofdgebruiker informatie</h6>
              <div class="col-md-12">
                <p class="input-label">Voornaam*</p>
                <a-input class="mb-2" v-model="userInformation.first_name" />
                <p class="input-label">Achternaam*</p>
                <a-input class="mb-2" v-model="userInformation.last_name" />
                <p class="input-label">E-mailadres*</p>
                <a-input class="mb-2" v-model="userInformation.email" />
                <p class="input-label">Wachtwoord*</p>
                <a-input-password class="mb-2" v-model="userInformation.password" />
                <p class="input-label">Telefoonnummer*</p>
                <a-input class="mb-2" v-model="userInformation.phone_number" />
              </div>
          </div>
        </div>
        <small>* Veld verplicht</small>
    </a-modal>
</div>
</template>
<script>
export default {
  props: ['fetchOrganizations'],
  computed: {
    user: {
      get: function () {
        return this.$store.state.user
      },
    },
  },
  data() {
    return {
      organizationModalVisible: false,
      organizationInformation: {},
      emptyOrganizationInformation: {
        name: undefined,
        departments_enabled: false,
        multiuser_enabled: false,
        btw_verlegd: false,
        include_csv: true,
        hide_reservations_to_organization: false,
        zipcode: undefined,
        streetname_housenumber: undefined,
        phone_number: undefined,
        coc_number: undefined,
        country: 'Nederland',
        city: undefined,
        invoice_email: undefined,
        commission: false,
        commission_amount: 0,
      },
      userInformation: {},
      emptyUserInformation: {
        first_name: undefined,
        last_name: undefined,
        email: undefined,
        password: undefined,
        phone_number: undefined,
      },
      newOrganization: true,
    }
  },
  methods: {
    openModal(organizationInformation = this.emptyOrganizationInformation) {
      this.organizationModalVisible = true
      this.organizationInformation = organizationInformation
      this.newOrganization = true
      this.userInformation = this.emptyUserInformation
      if (this.organizationInformation.id !== undefined) {
        this.newOrganization = false
        this.userInformation = null
      }
    },
    createOrUpdateOrganization() {
      this.$axios.post(`/organization/createOrUpdate`, {
        organization_id: this.organizationInformation.id ? this.organizationInformation.id : null,
        organization: this.organizationInformation,
        user: this.newOrganization ? this.userInformation : null
      },
      {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.fetchOrganizations()
        this.organizationModalVisible = false
      }).catch(error => {
        console.log(error)
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@700&display=swap');

  .input-label{
    margin-bottom: 0px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 10px;
  }
</style>